import { Grid, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useState } from "react";

import { IconButton } from "@material-ui/core";

import { Close } from "@material-ui/icons";

import { format, isValid, parse } from "date-fns";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import MomentLocaleUtils from "react-day-picker/moment";
import { CalendarIcon } from "./CalenderIcon.js";

export const DateSelectorDialog = ({
    openMergeInvoice,
    setOpenMergeInvoice,
    bookings,
    setSelectedBookingIds,
    selectedToDate,
    setSelectedToDate,
    selectedFromDate,
    setSelectedFromDate
}) => {
    const [toDateFocus, setToDateFocus] = useState(false);
    const [fromDateFocus, setFromDateFocus] = useState(false);
    const [filteredBookings, setFilteredBookings] = useState(bookings);

    const formatDate = (date, formatStr) => {
        return date ? format(date, formatStr) : "";
    };

    const handleSelectFrom = date => {
        const firstSecondOftheDate = new Date(date).setHours(0, 0, 0, 0);
        setSelectedFromDate(new Date(firstSecondOftheDate));
    };

    const handleSelectTo = date => {
        setSelectedToDate(new Date(new Date(date).setHours(23, 59, 59, 999)));
    };

    const parseDate = (str, formatStr) => {
        const parsedDate = parse(str, formatStr, new Date());
        return isValid(parsedDate) ? parsedDate : undefined;
    };

    const dineroModelClose = () => {
        setOpenMergeInvoice(false);
    };

    useEffect(() => {
        if (selectedFromDate && selectedToDate) {
            const fromDate = new Date(selectedFromDate).getTime();
            const toDate = new Date(selectedToDate).getTime();
            const filtered = bookings.filter(booking => {
                const bookingDate = parseInt(booking.from);
                return bookingDate >= fromDate && bookingDate <= toDate;
            });
            setFilteredBookings(filtered);
        } else {
            setFilteredBookings(bookings);
        }
    }, [selectedFromDate, selectedToDate, bookings]);

    return (
        <Dialog
            maxWidth="lg"
            open={openMergeInvoice}
            aria-labelledby="form-dialog-title"
            PaperProps={{
                style: {
                    width: "100%",
                    minHeight: "350px",
                    borderRadius: "25px",
                    padding: "40px",
                    maxWidth: "700px",
                    overflowY: "visible",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    margin: "10px"
                },
                className: "date-picker-popup"
            }}
            className="date-picker-popup">
            <Grid onClick={dineroModelClose}>
                <Close
                    style={{
                        color: "#00000059",
                        position: "absolute",
                        right: "40px",
                        fontSize: "40px",
                        cursor: "pointer"
                    }}
                    className="close-icon"
                />
            </Grid>
            <DialogTitle
                id="form-dialog-title"
                style={{ color: "black", fontSize: "22px !important", padding: "0px", paddingBottom: "5px" }}>
                Vælg behandlingsperiode
            </DialogTitle>
            <Typography variant="subtitle2" style={{ color: "#00000080", fontSize: "14px !important", padding: "0px" }}>
                Find alle klientens fakturaer for valgte tidsperiode
            </Typography>
            <DialogContent
                style={{
                    padding: "0px",
                    paddingTop: "15px",
                    overflowY: "visible",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    flex: "initial",
                    minHeight: "100px",
                    "@media screen and (max-width:600px)": {
                        minHeight: "200px"
                    }
                }}
                className="date-picker-content">
                <Grid container spacing={3} item xs={12} style={{ margin: "0px", padding: "20px 0px" }}>
                    <Grid
                        item
                        xs={12}
                        container
                        style={{ padding: "0px", paddingTop: "0px", flexWrap: "wrap", rowGap: "20px" }}>
                        <Grid item sm={6} xs={12} style={{ position: "relative" }} className="todate-input">
                            <Typography variant="subtitle2" style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                                Fra
                            </Typography>
                            <DayPickerInput
                                formatDate={date => formatDate(date, "yyyy-MM-dd")}
                                parseDate={str => parseDate(str, "yyyy-MM-dd")}
                                placeholder="Vælg en dato"
                                value={selectedFromDate}
                                onDayChange={handleSelectFrom}
                                onDayPickerShow={() => setFromDateFocus(true)}
                                onDayPickerHide={() => setFromDateFocus(false)}
                                inputProps={{
                                    IconButton,
                                    style: {
                                        width: "90%",
                                        padding: "10px 0px 10px 0px",
                                        border: "none",
                                        borderBottom: "1px solid #000",
                                        borderRadius: "0px",
                                        fontSize: "16px",
                                        color: "black",
                                        "&:focus-visible": {
                                            outline: "none"
                                        },
                                        "@media screen and (max-width:767px)": {
                                            width: "100%"
                                        }
                                    },
                                    className: "custom-day-picker-input"
                                }}
                                style={{
                                    width: "100%"
                                }}
                                dayPickerProps={{
                                    locale: "da",
                                    localeUtils: MomentLocaleUtils
                                }}
                            />
                            <CalendarIcon fromDateFocus={fromDateFocus} />
                        </Grid>
                        <Grid item sm={6} xs={12} style={{ position: "relative" }}>
                            <Typography variant="subtitle2" style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                                Til
                            </Typography>
                            <DayPickerInput
                                formatDate={date => formatDate(date, "yyyy-MM-dd")}
                                parseDate={str => parseDate(str, "yyyy-MM-dd")}
                                placeholder="Vælg en dato"
                                value={selectedToDate}
                                onDayChange={handleSelectTo}
                                onDayPickerShow={() => setToDateFocus(true)}
                                onDayPickerHide={() => setToDateFocus(false)}
                                inputProps={{
                                    style: {
                                        width: "100%",
                                        padding: "10px 0px 10px 0px",
                                        border: "none",
                                        borderBottom: "1px solid #000",
                                        borderRadius: "0px",
                                        fontSize: "16px",
                                        color: "black"
                                    },
                                    className: "custom-day-picker-input"
                                }}
                                style={{
                                    width: "100%"
                                }}
                                dayPickerProps={{
                                    locale: "da",
                                    localeUtils: MomentLocaleUtils
                                }}
                            />
                            <CalendarIcon fromDateFocus={toDateFocus} />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: "flex-start", padding: "0px" }}>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={!selectedFromDate || !selectedToDate || filteredBookings.length === 0}
                    onClick={() => {
                        const selectedBookingIds = filteredBookings.map(fb => fb.id);
                        setSelectedBookingIds(selectedBookingIds);
                    }}>
                    Find fakturaer
                </Button>
            </DialogActions>
        </Dialog>
    );
};
